import { datadogRum } from "@datadog/browser-rum";

/**
 * Product analytics for the PLG surfaces: one Datadog RUM custom action per
 * event, queryable in Product Analytics as `@action.name` with the properties
 * as context. Amplitude is switched off on 2026-09-30, and by decision only
 * the PLG home and products pages move; every other surface keeps its
 * Amplitude calls until it is retired or migrated on its own.
 *
 * Event names and property keys follow the Amplitude conventions verbatim so a
 * chart carries over one-to-one. Before the RUM SDK initialises (development,
 * mock mode) the call is buffered and never sent.
 */
export function trackProductEvent(event: string, properties?: object): void {
  datadogRum.addAction(event, properties);
}
